import { render, staticRenderFns } from "./documents-previewer-loader.vue?vue&type=template&id=bd290ed6"
import script from "./documents-previewer-loader.vue?vue&type=script&lang=js"
export * from "./documents-previewer-loader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports